// NAV SCROLL
window.addEventListener('scroll', () => {
  document.getElementById('nav').classList.toggle('scrolled', window.scrollY > 50);
});

// BURGER
document.getElementById('burger')?.addEventListener('click', () => document.getElementById('mobileMenu').classList.add('open'));
document.getElementById('mobileClose')?.addEventListener('click', () => document.getElementById('mobileMenu').classList.remove('open'));

// FILTRES
document.querySelectorAll('.fil').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.fil').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const f = btn.dataset.f;
    document.querySelectorAll('.prod').forEach((p, i) => {
      const show = f === 'all' || p.dataset.cat === f;
      p.classList.toggle('hidden', !show);
      if (show) p.style.animation = `fadeUp 0.4s ${i * 0.06}s ease both`;
    });
  });
});

// ==============================
// FICHE PRODUIT
// ==============================
let currentSlide = 0, totalSlides = 0, currentProduct = null;

function openProduct(card) {
  const total = parseInt(card.dataset.total || 1);
  const imgs = [];
  for (let i = 0; i < total; i++) {
    const src = card.dataset['img' + i];
    if (src) imgs.push(src);
  }
  currentProduct = {
    name: card.dataset.name,
    price: parseInt(card.dataset.price),
    handle: card.dataset.handle || ''
  };
  currentSlide = 0;
  totalSlides = imgs.length || 1;

  document.getElementById('pmTitle').textContent = card.dataset.name;
  document.getElementById('pmPrice').textContent = card.dataset.price + ' €';
  document.getElementById('pmDesc').textContent = card.dataset.desc;
  document.getElementById('pmTag').textContent = card.dataset.tag;

  // Stocker les images pour le changement
  window._krnImgs = imgs;

  const slider = document.getElementById('pmSlider');
  slider.innerHTML = '';
  slider.style.transform = '';

  // Afficher juste la première image
  const mainImg = document.createElement('img');
  mainImg.src = imgs[0];
  mainImg.alt = card.dataset.name;
  mainImg.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:#fff;';
  slider.appendChild(mainImg);
  slider.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#fff;';

  const dots = document.getElementById('pmDots');
  dots.innerHTML = imgs.map((_, i) => `<button class="pm-dot ${i === 0 ? 'active' : ''}" onclick="goToSlide(${i})"></button>`).join('');

  document.getElementById('pmPrev').style.display = imgs.length > 1 ? 'flex' : 'none';
  document.getElementById('pmNext').style.display = imgs.length > 1 ? 'flex' : 'none';

  document.querySelectorAll('.pm-sizes span').forEach(s => s.classList.remove('selected'));
  
  // Charger les tailles dynamiquement
  const pmSizes = document.getElementById('pmSizes');
  const variants = (card.dataset.variants || 'S,M,L,XL').split(',');
  const available = (card.dataset.variantsAvailable || '').split(',');
  pmSizes.innerHTML = variants.map((v, i) => {
    const isAvailable = available[i] !== 'false';
    return `<span class="${!isAvailable ? 'epuise' : ''}" style="${!isAvailable ? 'opacity:.35;text-decoration:line-through;cursor:not-allowed;pointer-events:none;' : ''}">${v.trim()}</span>`;
  }).join('');
  // Re-attacher les events sur les nouvelles spans
  pmSizes.querySelectorAll('span:not(.epuise)').forEach(s => {
    s.addEventListener('click', () => {
      pmSizes.querySelectorAll('span').forEach(x => x.classList.remove('selected'));
      s.classList.add('selected');
    });
  });
  document.getElementById('productOverlay').classList.add('active');
  document.getElementById('productModal').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeProduct() {
  document.getElementById('productOverlay').classList.remove('active');
  document.getElementById('productModal').classList.remove('active');
  document.body.style.overflow = '';
}

function goToSlide(n) {
  // Nouvelle approche: juste changer l image visible
  currentSlide = n;
  const slider = document.getElementById('pmSlider');
  const imgs = window._krnImgs || [];
  if (imgs[n]) {
    const img = slider.querySelector('img');
    if (img) {
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.2s';
      setTimeout(() => {
        img.src = imgs[n];
        img.style.opacity = '1';
      }, 200);
    }
  }
  document.querySelectorAll('.pm-dot').forEach((d, i) => d.classList.toggle('active', i === n));
}

document.getElementById('pmNext')?.addEventListener('click', () => goToSlide((currentSlide + 1) % totalSlides));
document.getElementById('pmPrev')?.addEventListener('click', () => goToSlide((currentSlide - 1 + totalSlides) % totalSlides));

// Swipe mobile
let tx = 0;
document.getElementById('pmSlider')?.addEventListener('touchstart', e => tx = e.touches[0].clientX);
document.getElementById('pmSlider')?.addEventListener('touchend', e => {
  const diff = tx - e.changedTouches[0].clientX;
  if (Math.abs(diff) > 50) goToSlide(diff > 0 ? (currentSlide + 1) % totalSlides : (currentSlide - 1 + totalSlides) % totalSlides);
});

document.addEventListener('keydown', e => { if (e.key === 'Escape') closeProduct(); });

document.querySelectorAll('.pm-sizes span').forEach(s => {
  s.addEventListener('click', () => {
    document.querySelectorAll('.pm-sizes span').forEach(x => x.classList.remove('selected'));
    s.classList.add('selected');
  });
});

// Ajouter depuis la fiche produit → vrai panier Shopify
document.getElementById('pmAddBtn')?.addEventListener('click', () => {
  if (!document.querySelector('.pm-sizes span.selected')) { toast('⚠️ Choisis une taille'); return; }
  if (!currentProduct) return;
  const size = document.querySelector('.pm-sizes span.selected').textContent.trim();
  const handle = currentProduct.handle;

  if (!handle) { toast('⚠️ Produit introuvable'); return; }

  fetch(`/products/${handle}.js`)
    .then(r => {
      if (!r.ok) throw new Error('Produit introuvable');
      return r.json();
    })
    .then(product => {
      const variant = product.variants.find(v => v.title.trim() === size) || product.variants[0];
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
    })
    .then(r => {
      if (!r.ok) throw new Error('Erreur ajout');
      return r.json();
    })
    .then(item => {
      toast('✓ ' + item.product_title + ' ajouté');
      fetchCart();
      fetch('/cart.js').then(r => r.json()).then(c => {
        document.getElementById('cartCount').textContent = c.item_count;
      });
      closeProduct();
      toggleCart();
    })
    .catch(err => {
      console.error(err);
      toast('⚠️ Vérifie que Shopify Payments est activé');
    });
});

// Ouvrir fiche produit
document.querySelectorAll('.open-product').forEach(btn => {
  btn.addEventListener('click', e => { e.stopPropagation(); openProduct(btn.closest('.prod')); });
});

document.querySelectorAll('.prod').forEach(card => {
  card.addEventListener('click', e => {
    if (e.target.classList.contains('open-product')) return;
    openProduct(card);
  });
});

// ==============================
// VRAI PANIER SHOPIFY AJAX
// ==============================
let cart = [];

function toggleCart() {
  document.getElementById('cartPanel').classList.toggle('active');
  document.getElementById('overlay').classList.toggle('active');
  if (document.getElementById('cartPanel').classList.contains('active')) {
    fetchCart();
  }
}
document.getElementById('cartBtn')?.addEventListener('click', toggleCart);

function fetchCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => renderCart(cart))
    .catch(() => {});
}

function renderCart(cartData) {
  const body = document.getElementById('cpBody');
  const count = document.getElementById('cartCount');
  const total = document.getElementById('totalPrice');
  if (!body) return;

  const itemCount = cartData.item_count || 0;
  const totalPrice = cartData.total_price || 0;

  count.textContent = itemCount;
  if (total) total.innerHTML = `<span>Total</span><strong>${(totalPrice / 100).toFixed(2)} €</strong>`;

  if (itemCount === 0) {
    body.innerHTML = '<p class="cp-empty">Ton panier est vide.</p>';
    return;
  }

  body.innerHTML = (cartData.items || []).map(item => `
    <div class="cart-item">
      <div>
        <p class="ci-name">${item.product_title}</p>
        <p class="ci-price">${(item.price / 100).toFixed(2)} € · ${item.variant_title} · Qté: ${item.quantity}</p>
      </div>
      <button class="ci-rm" onclick="removeFromCart('${item.key}')">✕</button>
    </div>
  `).join('');
}

function addToShopifyCart(variantId, size) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(item => {
    toast('✓ ' + item.product_title + ' ajouté');
    fetchCart();
    fetch('/cart.js').then(r => r.json()).then(c => {
      document.getElementById('cartCount').textContent = c.item_count;
    });
  })
  .catch(() => toast('⚠️ Erreur, réessaie'));
}

function removeFromCart(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(r => r.json())
  .then(cart => {
    renderCart(cart);
    document.getElementById('cartCount').textContent = cart.item_count || 0;
  })
  .catch(() => fetchCart());
}

document.getElementById('checkoutBtn')?.addEventListener('click', () => {
  fetch('/cart.js').then(r => r.json()).then(cart => {
    if (cart.item_count === 0) { toast('Ton panier est vide !'); return; }
    window.location.href = '/checkout';
  });
});

document.getElementById('checkoutBtn')?.addEventListener('click', () => {
  window.location.href = '/checkout';
});

// TOAST
function toast(msg) {
  document.querySelector('.toast-notif')?.remove();
  const t = document.createElement('div');
  t.className = 'toast-notif';
  t.textContent = msg;
  Object.assign(t.style, {
    position: 'fixed', bottom: '28px', left: '50%', transform: 'translateX(-50%)',
    background: '#111', border: '1px solid #222', color: '#efefef',
    padding: '12px 28px', fontFamily: "'Inter', sans-serif", fontSize: '13px',
    fontWeight: '500', letterSpacing: '1px', zIndex: '9999',
    boxShadow: '0 4px 24px rgba(0,0,0,.6)', whiteSpace: 'nowrap',
  });
  document.body.appendChild(t);
  setTimeout(() => { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; setTimeout(() => t.remove(), 300); }, 3200);
}

// SCROLL ANIM
const obs = new IntersectionObserver(entries => {
  entries.forEach((e, i) => {
    if (e.isIntersecting) {
      setTimeout(() => { e.target.style.animation = `fadeUp 0.5s ease both`; e.target.style.opacity = '1'; }, i * 70);
      obs.unobserve(e.target);
    }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.prod, .gar').forEach(el => { el.style.opacity = '0'; obs.observe(el); });
